import { NEW_PASSWORD_REQUIRED, MFA_SETUP, SOFTWARE_TOKEN_MFA, SMS_MFA } from '@/consts/challengeName'
import { Redirect } from '@/types/redirect'
import { SSOLoginResponse } from '@/types/loginResponse'

type InitFlow = (username: string, session: string, redirectUrlAfterLogin: string) => void
type InitOTPFlow = (username: string, session: string, deliveryMedium: string, sentTo: string, redirectUrlAfterLogin: string) => void

export const challengeHandler = (redirect: Redirect, initTotpLogin: InitFlow, initResetPassword: InitFlow, initOtpLogin: InitOTPFlow) =>
  (username: string, loginResponse: SSOLoginResponse, redirectUrlAfterLogin: string) => {
    if (!loginResponse.ChallengeName) return

    const challengeActions = {
      [NEW_PASSWORD_REQUIRED]: () => {
        initResetPassword(username, loginResponse.Session as string, redirectUrlAfterLogin)
        redirect('ResetView')
      },
      [MFA_SETUP]: () => redirect('MfaSetup'),
      [SOFTWARE_TOKEN_MFA]: () => {
        // This is due to the fact the accessToken is not set in the session when the user is not logged in yet due to mfa.
        const session = loginResponse.mfaRequired ? loginResponse.accessToken : loginResponse.Session as string
        initTotpLogin(username, session, redirectUrlAfterLogin)
        redirect('SoftwareTokenMfa')
      },
      [SMS_MFA]: () => {
        // This is due to the fact the accessToken is not set in the session when the user is not logged in yet due to mfa.
        const session = loginResponse.mfaRequired ? loginResponse.accessToken : loginResponse.Session as string
        initOtpLogin(
          username,
          session,
          loginResponse.ChallengeParameters.CODE_DELIVERY_DELIVERY_MEDIUM as string,
          loginResponse.ChallengeParameters.CODE_DELIVERY_DESTINATION as string,
          redirectUrlAfterLogin)
        redirect('OtpMfa')
      }
    }

    challengeActions[loginResponse.ChallengeName]
      ? challengeActions[loginResponse.ChallengeName]()
      : console.error('Unknown challenge')
  }
